import { PaletteOptions } from '@mui/material';

const palette: PaletteOptions = {
	text: {
		primary: '#252525'
	},
	info: {
		main: '#FAAE16'
	},
	primary: {
		main: '#5e524e'
	},
	secondary: {
		main: '#FAAE16'
	}
};

export default palette;
